import styles from "./reminder-card.module.css";
import { getEnvVar } from "@commons-monorepo/index";
import { formatCurrency } from "@commons-monorepo/index";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface ReminderCardProps {
  productName: string;
  image: string;
  price: number;
  ownerId: string;
  productId: string;
  onClick: () => void;
}

const ReminderCard = ({
  productName,
  image,
  price,
  ownerId,
  productId,
  onClick
}: ReminderCardProps) => {
  const domain = getEnvVar("PUBLIC_HOST");
  const { storeMetadata } = useOutletContext<any>();
  const { t } = useTranslation();

  return (
    <a
      onClick={onClick}
      href={`${domain}/catalogo/${ownerId}/producto/${productId}`}>

      <div className={styles.card}>
        <div className={styles.image}>
          <span className={styles.tag}>{t("reminderToBecomeExpert.tag")}</span>
          <img src={image} alt='experto' />
        </div>
        <div className={styles.texts}>
          <div className={styles.title}>{productName}</div>
          <div className={styles.price}>
            {formatCurrency(price, {
              locale: storeMetadata?.locale,
              currency: storeMetadata?.currency
            })}
          </div>
        </div>
      </div>
    </a>);

};

export default ReminderCard;